export default __webpack_public_path__ + "static/media/ic-course.cfe1e117.svg";